<bn-web-ui-card
  class="mb-2 color-dark-7"
  heading="Curated threat lists"
  [isMaxWidth]="true"
  [learnMore]="{ href: 'https://bunny.net/docs/shield/access-lists' }">
  Choose from a selection of continuously updated, managed threat lists to automatically filter traffic based on specific risk categories, such as known
  malicious IPs, botnets, anonymizing proxies, and more. Apply allow, block, or challenge actions to requests that match your selected lists, with no manual
  maintenance required.
</bn-web-ui-card>

<app-shield-action-precedence-component />

@for (group of groupedManagedLists(); track group.plan) {
  <div class="bn-shield-threat-group-item mt-2 text-500-medium px-4 py-2">
    {{ PlanType[group.plan] }} lists
    <bn-web-ui-badge
      color="premium"
      contentClass="ms-2"
      >{{ PlanType[group.plan] }}</bn-web-ui-badge
    >
  </div>
  @for (item of group.items; track $index) {
    <app-shield-access-lists-threat-item
      listKey="managedLists"
      [item]="item"
      [showUpgradeTooltips]="true" />
  }
}

@if (storeManagedList() === null || (storeManagedList()?.length === 0 && isLoading())) {
  <app-shield-access-lists-threat-item [isSkeleton]="true" />
}
